import { createContext } from "react";

// The SSR renderer provides a plain object here and reads `code` back after the
// render, so a page that ends up showing <NotFound /> is answered with a 404
// instead of a 200. Stands in for the StaticRouter `context` prop v6 removed.
// In the browser there is no provider and the value is null.
const ResponseStatusContext = createContext(null);

export default ResponseStatusContext;
